import * as React from 'react';
import * as styles from './styles.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { IconButton } from '@fluentui/react/lib/Button';
import { FocusZone } from '@fluentui/react/lib/FocusZone';
import { Modal } from '@fluentui/react/lib/Modal';
import { getIsDarkTheme } from 'owa-fabric-theme';
import { ControlIcons } from 'owa-control-icons';
import { getProjectPreviewId, closeProjectPreview } from 'owa-timestream-projectmanager';
import { ProjectIdProvider } from 'owa-timestream-asset-sdk';
import { AssetRegistryProvider } from '../hooks/useAssetRegistry';
import type { TimeStreamCanvasPreviewProps } from '../schema';
import TimeStreamCanvasDocumentLayer from './TimeStreamCanvasDocumentLayer';
import TimeStreamCanvasPreviewInfo from './TimeStreamCanvasPreviewInfo';
import loc from 'owa-localize';
import { cancel } from 'owa-locstrings/lib/strings/cancel.locstring.json';

export default observer(function TimeStreamCanvasPreview({
    assetRegistry,
    canvasStyles,
}: TimeStreamCanvasPreviewProps) {
    const projectPreviewId = getProjectPreviewId();
    const className = classNames(styles.timeStreamPreviewCanvas, {
        [styles.timeStreamCanvasDark]: getIsDarkTheme(),
    });

    if (!projectPreviewId) {
        return null;
    }

    return (
        <Modal
            className={styles.canvasPreviewPopout}
            containerClassName={styles.canvasPreviewContainer}
            scrollableContentClassName={styles.projectPreviewContent}
            isOpen={!!projectPreviewId}
            isBlocking={false}
            onDismiss={closeProjectPreview}>
            <AssetRegistryProvider value={assetRegistry}>
                <ProjectIdProvider value={projectPreviewId}>
                    <div className={styles.projectPreviewContent}>
                        <FocusZone
                            disabled={true}
                            key={projectPreviewId}
                            className={className}
                            style={canvasStyles}>
                            <div className={styles.canvasBodyPreview}>
                                <TimeStreamCanvasDocumentLayer />
                            </div>
                        </FocusZone>
                        <TimeStreamCanvasPreviewInfo />
                        <IconButton
                            text={loc(cancel)}
                            ariaLabel={loc(cancel)}
                            className={styles.previewCloseButton}
                            iconProps={{ iconName: ControlIcons.Cancel }}
                            onClick={closeProjectPreview}
                        />
                    </div>
                </ProjectIdProvider>
            </AssetRegistryProvider>
        </Modal>
    );
});
